"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _matchFirstNumber = _interopRequireDefault(require("./matchFirstNumber"));
var _formattedPrice = _interopRequireDefault(require("./formatted-price"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var getPriceReduction = function getPriceReduction(priceFrom, priceTo) {
  var from = (0, _matchFirstNumber["default"])(priceFrom);
  var to = (0, _matchFirstNumber["default"])(priceTo);
  var reduction = from - to;
  if (reduction > 0) {
    // when reduction returns a float e.g. 15.04666
    // ensure that rounding is done before calling formattedPrice to return
    // expected value of 15.05 and not 15.04
    return Math.round(parseFloat(reduction) * 100) / 100;
  } else {
    return null;
  }
};
var calculatePriceReduction = function calculatePriceReduction(price) {
  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-GB';
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GBP';
  var amountFrom = null;
  var amountTo = null;
  // 4 scenarios:
  // scenario 1: was (string/number) & now (string)
  // scenario 2: was (string/number) & now (object)
  // scenario 3: was (object) & now (string/number)
  // scenario 4: was (object) & now (object)
  if (!!price.was && !!price.now) {
    if (_typeof(price.was) !== 'object' && _typeof(price.now) !== 'object') {
      // scenario 1 { was: '200.00', now: '100.00' }
      var amount = getPriceReduction(price.was, price.now);
      return amount && (0, _formattedPrice["default"])(amount, country, currency);
    } else if (_typeof(price.was) !== 'object' && _typeof(price.now) === 'object') {
      // scenario 2 { was: '20.00', now: { from: '1.25', to: '8.00' } }
      amountFrom = getPriceReduction(price.was, price.now.from);
      amountTo = getPriceReduction(price.was, price.now.to);
    } else if (_typeof(price.was) === 'object' && _typeof(price.now) !== 'object') {
      // scenario 3 { was: { from: '1.25', to: '8.00' }, now: '20.00' }
      amountFrom = getPriceReduction(price.was.from, price.now);
      amountTo = getPriceReduction(price.was.to, price.now);
    } else if (_typeof(price.was) === 'object' && _typeof(price.now) === 'object') {
      // scenario 4 { was: { from: '2.50', to: '16.00' }, now: { from: '1.25', to: '8.00' } }
      amountFrom = getPriceReduction(price.was.from, price.now.from);
      amountTo = getPriceReduction(price.was.to, price.now.to);
    }

    // sort array and destructure
    var _sort = [amountFrom, amountTo].sort(function (a, b) {
      return a - b;
    });
    var _sort2 = _slicedToArray(_sort, 2);
    amountFrom = _sort2[0];
    amountTo = _sort2[1];
    if (!amountFrom && !amountTo) {
      return null;
    }
    var from = (0, _formattedPrice["default"])(amountFrom, country, currency);
    var to = (0, _formattedPrice["default"])(amountTo, country, currency);
    return from !== to ? "".concat(from, " \u2013 ").concat(to) : from;
  } else {
    return null;
  }
};
var _default = exports["default"] = calculatePriceReduction;